import { render, staticRenderFns } from "./sub-menu.vue?vue&type=template&id=41721d1d&scoped=true&functional=true&"
import script from "./sub-menu.vue?vue&type=script&lang=js&"
export * from "./sub-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "41721d1d",
  null
  
)

export default component.exports